import { render, staticRenderFns } from "./PrecalificadorGralDatos.view.vue?vue&type=template&id=79f1ca63&scoped=true&"
import script from "./PrecalificadorGralDatos.view.vue?vue&type=script&lang=js&"
export * from "./PrecalificadorGralDatos.view.vue?vue&type=script&lang=js&"
import style0 from "./PrecalificadorGralDatos.view.vue?vue&type=style&index=0&id=79f1ca63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f1ca63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VForm,VIcon,VImg,VRow,VTextField})
